import React from 'react';
import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogTitle from '@material-ui/core/DialogTitle';
import SystemLabel from '../../system/SystemLabel/SystemLabel';
import VideocamIcon from '@material-ui/icons/Videocam';
import CallEndIcon from '@material-ui/icons/CallEnd';
import AccountCircleIcon from '@material-ui/icons/AccountCircle';
import { Avatar } from '@material-ui/core';
import PersonIcon from '@material-ui/icons/Person';
import './Animation.css'
import { isUsingChrome } from '../../helpers/browser.helper';



export default function OnVideCallModal({ target = null, deny = () => null, accept = () => null, lang = null }) {
    let isChrome = isUsingChrome();
    return (
        <div>
            <Dialog
                open={true}
                onClose={() => null}
                aria-labelledby="alert-dialog-title"
                aria-describedby="alert-dialog-description"
            >
                <DialogContent style={{ minWidth: 300 }}>
                    <DialogContentText component="div" id="alert-dialog-description">
                        <div className="call-animation-incomming" style={{ textAlign: 'center' }}>
                            <PersonIcon style={{
                                top: '23%',
                                position: 'absolute',
                                color: '#fff',
                                left: '23%',
                                fontSize: '50px'
                            }} />
                        </div>
                        <div style={{ textAlign: 'center', padding: '8px 5px' }}>
                            <div style={{ fontSize: 20, color: '#222' }}>
                                {target ? target.name : '(?)'}
                            </div>
                            <div style={{ fontSize: 16 }}><SystemLabel name="IsCallingYou" languageCode={lang} /></div>
                        </div>
                        {!isChrome ?
                            <div style={{ textAlign: 'center', padding: '8px 5px' }}>
                                <div style={{ fontSize: 16 }}><SystemLabel name="YouNeedGoogleChromeForVideoMeeting" languageCode={lang} /></div>
                            </div>
                            : null}
                    </DialogContentText>

                </DialogContent>

                <DialogActions className="call-actionbar">
                    <Button className="call-btn end" onClick={deny} color="primary">
                        <CallEndIcon />
                    </Button>
                    {isChrome ? <Button className="call-btn accept" onClick={accept} color="primary" autoFocus>
                        <VideocamIcon />
                    </Button> : null}
                </DialogActions>
            </Dialog>
        </div>
    );
}